module.exports = __webpack_public_path__ + "static/media/Logo_Animado_Sttelar_Atomo_Fundo_Preto.3cddab0d.mp4";